import { hasToString } from '../../functions/has-to-string/has-to-string.function';

export type UniqueIdentifierPredicate<T> = (element: T) => string | number;

export function createPredicateFunctionFromStringFunction<T>(
  key: string,
): UniqueIdentifierPredicate<T> {
  return (element: T): string | number => {
    if (typeof element === 'string' || typeof element === 'number') {
      return element;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const isKeyOf = (targetElement: T, targetKey: any): targetKey is keyof T => {
      return (
        typeof targetElement === 'object' &&
        Object.prototype.hasOwnProperty.call(element, targetKey)
      );
    };

    if (element && isKeyOf(element, key) && typeof element === 'object') {
      if (typeof element[key] === 'string' || typeof element[key] === 'number') {
        return element[key] as string | number;
      }
    }

    if (hasToString(element)) {
      return element.toString();
    }

    throw Error(
      "Given predicate key doesn't return a string or number, create a predicate function instead",
    );
  };
}
